﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType, NoteType } from '../models/enums';
import { NoteObject } from '../models/note-object';
import DmaFooter from './DmaFooter';

import { Button } from 'devextreme-react/button';
import HtmlEditor from 'devextreme-react/html-editor';

export default function NoteViewerFullPage() {
    const [note, setNote] =
        useState<NoteObject>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getNote();
    }, []);

    const parts = window.location.href.split('/');
    const parentId = parts.length > 2 ? parts[parts.length - 2] : undefined;
    const noteType = parts.length > 1 ? parts[parts.length - 1] : undefined;

    return (
        <div className="pw-form-container">
            <div className="lq-header pw-margin-top-05 pw-bg-green">
                <div className="lq-header-title">{note && note.title ? note.title : 'Notes'}</div>
                <div className="title-bar-spacer" />

                <Button id="exportToPdfButton" text="Export to PDF" icon="pdffile" type="success"
                    className="pw-button"
                    hint="export to pdf"
                    height='1.8rem'
                    onClick={exportNoteToPdf} />
            </div>

            <div id="NoteViewerContainer" className="pw-form-section">
                <HtmlEditor height="100%" readOnly={true}
                    value={note && note.text ? note.text : undefined} />
            </div>

            <DmaFooter />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    async function getNote() {
        if (noteType && parentId) {
            await CrudFunctions.getData(`notes/notesbyparentidandnotetype/${parentId}/${noteType}`)
                .then(data => {
                    if (data && data.length > 0) {
                        let returnedNote = data[0] as NoteObject;
                        
                        if (returnedNote) {
                            returnedNote.text = atob(returnedNote.base64Blob);
                            setNote(returnedNote);
                        }
                    }
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Note");
                });
        }
    }

    async function exportNoteToPdf() {
        if (note && parentId && noteType) {
            await CrudFunctions.getDataBlob(`notes/notetopdf/${parentId}/${noteType}`)
                .then(blob => {
                    let a = document.createElement("a") as HTMLAnchorElement;

                    document.body.appendChild(a);
                    a.style.display = "none";

                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = `${note.title ? note.title : 'note'}.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(url);

                    /*
                    //to open PDF in browser:
                    let file = window.URL.createObjectURL(blob);
                    window.open(file, "_blank");
                    */
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Note");
                });
        }
    }
    
    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


}